import React, { ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import { DEFAULT_ROUTE, IHX_LOGO } from '../../../shared/constants/commonConstants';

const IhxLogo = (): ReactElement => {
  const history = useHistory();

  const onInitDefault = (): void => {
    history.push(DEFAULT_ROUTE);
  };

  return (
    <div className="logo" onClick={onInitDefault}>
      <img src={IHX_LOGO} alt="Logo" />
    </div>
  );
};

export default IhxLogo;
